import { addBusinessDays, isWithinInterval, setMinutes } from "date-fns";

function getPascalFullMoonDates() {
  return [
    [3, 14],
    [3, 3],
    [2, 23],
    [3, 11],
    [2, 31],
    [3, 18],
    [3, 8],
    [2, 28],
    [3, 16],
    [3, 5],
    [2, 25],
    [3, 13],
    [3, 2],
    [2, 22],
    [3, 10],
    [2, 30],
    [3, 17],
    [3, 7],
    [2, 27],
  ];
}

function getEasterHolidays(year) {
  const pascalFullMoonMonthDay = getPascalFullMoonDates();
  const [refMonth, refDay] = pascalFullMoonMonthDay[year % 19];
  const movingDate = new Date(year, refMonth, refDay);
  const holidays = [];
  movingDate.setDate(movingDate.getDate() + 7 - movingDate.getDay());
  holidays.push({
    date: new Date(movingDate),
    name: "Páscoa",
  });
  movingDate.setDate(movingDate.getDate() - 2);
  holidays.push({
    date: new Date(movingDate),
    name: "Sexta-feira Santa",
  });
  movingDate.setDate(movingDate.getDate() - 46);
  holidays.push({
    date: new Date(movingDate),
    name: "Segunda de Carnaval",
  });
  movingDate.setDate(movingDate.getDate() + 1);
  holidays.push({
    date: new Date(movingDate),
    name: "Terça de Carnaval",
  });
  movingDate.setDate(movingDate.getDate() + 1);
  holidays.push({
    date: new Date(movingDate),
    name: "Quarta de Cinzas",
  });
  movingDate.setDate(movingDate.getDate() + 106);
  holidays.push({
    date: new Date(movingDate),
    name: "Corpus Christi",
  });
  return holidays;
}

function getNationalHolidays(year) {
  const fixedHolidays = [
    { date: new Date(year, 0, 1), name: "Confraternização mundial" },
    { date: new Date(year, 3, 21), name: "Tiradentes" },
    { date: new Date(year, 4, 1), name: "Dia do trabalho" },
    { date: new Date(year, 8, 7), name: "Independência do Brasil" },
    { date: new Date(year, 9, 12), name: "Nossa Senhora Aparecida" },
    { date: new Date(year, 10, 4), name: "Finados" },
    { date: new Date(year, 10, 15), name: "Proclamação da República" },
    { date: new Date(year, 11, 25), name: "Natal" },
  ];
  return fixedHolidays;
}

function filterHollidayOnWeekend(holidays) {
  return holidays.filter(holiday => {
    const holidayWeekDay = holiday.date.getDay();
    return !(holidayWeekDay === 6 || holidayWeekDay === 0);
  });
}

function getLocalHolidays(year, uf) {
  const localHolidays = [
    { date: new Date(year, 3, 23), name: "Dia de São Jorge", uf: "RJ" },
  ];

  return localHolidays.filter(fh => fh.uf === uf);
}

function addBusinessDaysIgnoreHolidays(days, uf) {

  if (!days || Number.isNaN(days) || !uf) {
    return
  }


  let now = new Date();

  const offset = now.getTimezoneOffset();

  if (offset !== 0) {
    now = setMinutes(now, offset)
  }

  const currentYear = now.getFullYear();

  const easterHolidaysCurrentYear = getEasterHolidays(currentYear);
  const nationalHolidaysCurrentYear = getNationalHolidays(currentYear);
  const easterHolidaysNextYear = getEasterHolidays(currentYear + 1);
  const nationalHolidaysNextYear = getNationalHolidays(currentYear + 1);
  const localHolidaysCurrentYear = getLocalHolidays(currentYear, uf);
  const localHolidaysNextYear = getLocalHolidays(currentYear + 1, uf);

  const allHolidays = [
    ...easterHolidaysCurrentYear,
    ...nationalHolidaysCurrentYear,
    ...localHolidaysCurrentYear,
    ...easterHolidaysNextYear,
    ...nationalHolidaysNextYear,
    ...localHolidaysNextYear,
  ];

  const holidaysInWeekdays = filterHollidayOnWeekend(allHolidays);


  let calculatedBusinessDays = addBusinessDays(now, days || 2);

  holidaysInWeekdays.forEach(holiday => {
    if (
      isWithinInterval(holiday.date, {
        start: now,
        end: calculatedBusinessDays,
      })
    ) {
      calculatedBusinessDays = addBusinessDays(calculatedBusinessDays, 1);
    }
  });

  return calculatedBusinessDays?.toString();
}

export { addBusinessDaysIgnoreHolidays }
